import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { Common } from 'src/app/common';
import { PaymentService } from 'src/app/services/payment.service';
import { SessionService } from 'src/app/services/session.service';

@Component({
  selector: 'app-send-payment-receipt',
  templateUrl: './send-payment-receipt.component.html',
  styleUrls: ['./send-payment-receipt.component.scss']
})
export class SendPaymentReceiptComponent implements OnInit {
  @Input() receiptId: string = '';

  public receiptSent: boolean = false;
  public sendErrorMessage: string = '';
  public emailAddress: string = '';

  constructor(
    private paymentService: PaymentService,
    private sessionService: SessionService) { }

  ngOnInit(): void {
  }

  public isEmailAddressInputDisabled(): boolean {
    return this.receiptSent;
  }

  public isSendButtonDisabled(): boolean {
    return _.isNil(this.emailAddress) || this.emailAddress === '' || this.receiptSent;
  }

  public isErrorMessageVisible(): boolean {
    return !_.isNil(this.sendErrorMessage) && this.sendErrorMessage !== '';
  }

  public getEmailAddressPattern(): string {
    return Common.getValidationEmailAddressRegex();
  }

  public onSendButtonClick(): void {
    this.sendEmailReceipt();
  }

  private sendEmailReceipt(): void {
    this.sessionService.showProcessing();
    this.sendErrorMessage = '';

    this.paymentService.sendPaymentReceipt(this.receiptId, this.emailAddress).subscribe({
      next: () => this.sendEmailReceiptOk(),
      error: (error) => this.sendEmailReceiptError(error.error)
    });
  }

  private sendEmailReceiptOk(): void {
    this.receiptSent = true;

    this.sessionService.hideProcessing();
  }

  private sendEmailReceiptError(error: any): void {
    this.sendErrorMessage = error.message;

    this.sessionService.hideProcessing();
  }
}
